import script from "./GlobalNoticeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalNoticeDialog.vue?vue&type=script&setup=true&lang=js"

import "./GlobalNoticeDialog.vue?vue&type=style&index=0&id=d1786320&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1786320"]])

export default __exports__